import { Menu } from '../../../models/Menu';

export const CLIENT_TABS: Menu[] = [
    { text: 'clients.view.profile', url: 'profile', icon: '', subItems: [] },
    { text: 'clients.view.contracts', url: 'contracts', icon: '', subItems: [] },
    { text: 'clients.view.payment_info', url: 'payment-info', icon: '', subItems: [] },
    { text: 'clients.view.trainings', url: 'trainings', icon: '', subItems: [] },
    { text: 'clients.view.training_blocks', url: 'training-blocks', icon: '', subItems: [] },
    { text: 'clients.view.invitations', url: 'referral-program', icon: '', subItems: [] },
    { text: 'clients.view.attendance', url: 'attendance', icon: '', subItems: [] },
    { text: 'clients.view.events', url: 'events', icon: '', subItems: [] },
    { text: 'chat.chat', url: 'chat', icon: '', subItems: [] },
    { text: 'clients.view.privacy_consents', url: 'privacy-and-notifications', icon: '', subItems: [] },
    { text: 'clients.view.mobile_devices', url: 'mobile-devices', icon: '', subItems: [] },
];
